import React from 'react';
import { Box, Container, Typography, Divider } from '@mui/material';
import { colors } from '../components/Theme/WebTheme';
import { FONT_FAMILY } from '../common/sharedFunctions';
import Header from "components/Header/Header.js";
import HomeFooter from "components/Footer/HomeFooter.js";
import HeaderLinks from "components/Header/HeaderLinks.js";

const dashboardRoutes = [];

const companyLegal = {
  legalName: 'ALLO DRIVER (SARWA)',
  form: 'SAS, société par actions simplifiée',
  address: 'SARWA, BOITE AUX LETTRES 21 53 AVENUE GAMBETTA 82000 MONTAUBAN',
  siren: '890 515 737',
  siret: '890 515 737 00041',
  vat: 'FR92 890 515 737',
  eori: 'Pas de n° EORI valide',
  naf: '63.12Z - Portails Internet',
  naf2025: '62.10Y - Activités de programmation informatique',
  inseeRegistrationDate: '01/11/2020',
  rneRegistrationDate: '02/11/2020',
  creationDate: '01/11/2020',
  category: 'Petite ou Moyenne Entreprise (PME), en 2023',
  workforce: 'Unité employeuse (au moins un salarié)',
  collectiveAgreement: 'Non renseignée',
  email: 'contact@allôdriver.com',
  phone: '+33 6 64 68 00 61'
};

const LegalNotice = (props) => {
  const { ...rest } = props;

  return (
    <div style={{ backgroundColor: '#000', minHeight: '100vh' }}>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "primary"
        }}
        {...rest}
      />

      <Box
        sx={{
          pt: { xs: 12, md: 15 },
          pb: 8,
          minHeight: '100vh'
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h1"
            sx={{
              fontFamily: FONT_FAMILY,
              fontSize: { xs: '32px', md: '48px' },
              fontWeight: 800,
              color: colors.Button_Primary,
              mb: 2,
              textAlign: 'center'
            }}
          >
            Mentions Légales
          </Typography>

          <Typography
            sx={{
              fontFamily: FONT_FAMILY,
              fontSize: { xs: '14px', md: '16px' },
              color: 'rgba(255,255,255,0.6)',
              textAlign: 'center',
              mb: 6
            }}
          >
            Dernière mise à jour : 6 mai 2026
          </Typography>

          <Box sx={{ color: '#fff' }}>
            {/* Éditeur du site */}
            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h4"
                sx={{
                  fontFamily: FONT_FAMILY,
                  fontSize: { xs: '20px', md: '24px' },
                  fontWeight: 700,
                  color: colors.Button_Primary,
                  mb: 2
                }}
              >
                1. Éditeur du site
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 1 }}>
                <strong>Dénomination :</strong> {companyLegal.legalName}
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 1 }}>
                <strong>Forme juridique :</strong> {companyLegal.form}
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 1 }}>
                <strong>Siège social :</strong> {companyLegal.address}
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 1 }}>
                <strong>SIREN :</strong> {companyLegal.siren}
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 1 }}>
                <strong>SIRET du siège social :</strong> {companyLegal.siret}
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 1 }}>
                <strong>N° TVA intracommunautaire :</strong> {companyLegal.vat}
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 1 }}>
                <strong>N° EORI :</strong> {companyLegal.eori}
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 1 }}>
                <strong>Activité principale (NAF/APE) :</strong> {companyLegal.naf}
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 1 }}>
                <strong>Activité principale (NAF 2025) :</strong> {companyLegal.naf2025}
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 1 }}>
                <strong>Inscription INSEE :</strong> {companyLegal.inseeRegistrationDate} - <strong>RNE (INPI) :</strong> {companyLegal.rneRegistrationDate}
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 1 }}>
                <strong>Date de création :</strong> {companyLegal.creationDate} - <strong>Catégorie :</strong> {companyLegal.category}
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 1 }}>
                <strong>Effectif salarié :</strong> {companyLegal.workforce} - <strong>Convention collective :</strong> {companyLegal.collectiveAgreement}
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 1 }}>
                <strong>Email :</strong> {companyLegal.email}
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 1 }}>
                <strong>Téléphone :</strong> {companyLegal.phone}
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8 }}>
                <strong>Directeur de la publication :</strong> Stéphane De Inegri
              </Typography>
            </Box>

            <Divider sx={{ borderColor: 'rgba(212, 175, 55, 0.2)', my: 4 }} />

            {/* Hébergeur */}
            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h4"
                sx={{
                  fontFamily: FONT_FAMILY,
                  fontSize: { xs: '20px', md: '24px' },
                  fontWeight: 700,
                  color: colors.Button_Primary,
                  mb: 2
                }}
              >
                2. Hébergeur du site
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 1 }}>
                <strong>Nom :</strong> Firebase Hosting (Google LLC)
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 1 }}>
                <strong>Adresse :</strong> 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8 }}>
                <strong>Site web :</strong> <a href="https://firebase.google.com" target="_blank" rel="noopener noreferrer" style={{ color: colors.Button_Primary }}>firebase.google.com</a>
              </Typography>
            </Box>

            <Divider sx={{ borderColor: 'rgba(212, 175, 55, 0.2)', my: 4 }} />

            {/* Propriété intellectuelle */}
            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h4"
                sx={{
                  fontFamily: FONT_FAMILY,
                  fontSize: { xs: '20px', md: '24px' },
                  fontWeight: 700,
                  color: colors.Button_Primary,
                  mb: 2
                }}
              >
                3. Propriété intellectuelle
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 2 }}>
                L'ensemble du contenu présent sur le site et l'application mobile Allô Driver (textes, images, graphismes, logos, icônes, sons, logiciels, bases de données) est la propriété exclusive d'Allô Driver ou de ses partenaires, et est protégé par les lois françaises et internationales relatives à la propriété intellectuelle.
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8 }}>
                Toute reproduction, représentation, modification, publication, transmission, dénaturation, totale ou partielle du site ou de son contenu, par quelque procédé que ce soit, et sur quelque support que ce soit est interdite sans l'autorisation écrite préalable d'Allô Driver.
              </Typography>
            </Box>

            <Divider sx={{ borderColor: 'rgba(212, 175, 55, 0.2)', my: 4 }} />

            {/* Protection des données */}
            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h4"
                sx={{
                  fontFamily: FONT_FAMILY,
                  fontSize: { xs: '20px', md: '24px' },
                  fontWeight: 700,
                  color: colors.Button_Primary,
                  mb: 2
                }}
              >
                4. Protection des données personnelles (RGPD)
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 2 }}>
                Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 2 }}>
                <strong>Données collectées :</strong> Nom, prénom, email, numéro de téléphone, adresse, localisation GPS (uniquement pour les trajets), historique des courses, informations de paiement (cryptées).
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 2 }}>
                <strong>Finalités :</strong> Gestion des réservations, facturation, amélioration du service, communication commerciale (avec consentement).
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 2 }}>
                <strong>Conservation :</strong> Les données sont conservées pendant la durée nécessaire aux finalités pour lesquelles elles sont collectées, et conformément aux obligations légales.
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8 }}>
                Pour exercer vos droits, contactez-nous à : <a href={`mailto:${companyLegal.email}`} style={{ color: colors.Button_Primary }}>{companyLegal.email}</a>
              </Typography>
            </Box>

            <Divider sx={{ borderColor: 'rgba(212, 175, 55, 0.2)', my: 4 }} />

            {/* Cookies */}
            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h4"
                sx={{
                  fontFamily: FONT_FAMILY,
                  fontSize: { xs: '20px', md: '24px' },
                  fontWeight: 700,
                  color: colors.Button_Primary,
                  mb: 2
                }}
              >
                5. Cookies
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 2 }}>
                Le site utilise des cookies pour améliorer l'expérience utilisateur, analyser le trafic (Google Analytics) et mémoriser vos préférences.
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8 }}>
                Vous pouvez désactiver les cookies dans les paramètres de votre navigateur. Cependant, certaines fonctionnalités du site peuvent ne pas fonctionner correctement.
              </Typography>
            </Box>

            <Divider sx={{ borderColor: 'rgba(212, 175, 55, 0.2)', my: 4 }} />

            {/* Responsabilité */}
            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h4"
                sx={{
                  fontFamily: FONT_FAMILY,
                  fontSize: { xs: '20px', md: '24px' },
                  fontWeight: 700,
                  color: colors.Button_Primary,
                  mb: 2
                }}
              >
                6. Limitation de responsabilité
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8, mb: 2 }}>
                Allô Driver s'efforce de fournir des informations exactes et à jour. Toutefois, nous ne pouvons garantir l'exactitude, la complétude ou l'actualité des informations présentes sur le site.
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8 }}>
                Allô Driver ne saurait être tenu responsable des dommages directs ou indirects résultant de l'utilisation du site ou de l'impossibilité d'y accéder.
              </Typography>
            </Box>

            <Divider sx={{ borderColor: 'rgba(212, 175, 55, 0.2)', my: 4 }} />

            {/* Droit applicable */}
            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h4"
                sx={{
                  fontFamily: FONT_FAMILY,
                  fontSize: { xs: '20px', md: '24px' },
                  fontWeight: 700,
                  color: colors.Button_Primary,
                  mb: 2
                }}
              >
                7. Droit applicable et juridiction compétente
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8 }}>
                Les présentes mentions légales sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.
              </Typography>
            </Box>

            <Divider sx={{ borderColor: 'rgba(212, 175, 55, 0.2)', my: 4 }} />

            {/* Contact CNIL */}
            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h4"
                sx={{
                  fontFamily: FONT_FAMILY,
                  fontSize: { xs: '20px', md: '24px' },
                  fontWeight: 700,
                  color: colors.Button_Primary,
                  mb: 2
                }}
              >
                8. Réclamation auprès de la CNIL
              </Typography>
              <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '16px', lineHeight: 1.8 }}>
                Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL) :<br />
                <strong>CNIL</strong><br />
                3 Place de Fontenoy<br />
                TSA 80715<br />
                75334 PARIS CEDEX 07<br />
                Tél : 01 53 73 22 22<br />
                <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" style={{ color: colors.Button_Primary }}>www.cnil.fr</a>
              </Typography>
            </Box>
          </Box>
        </Container>
      </Box>

      <HomeFooter />
    </div>
  );
};

export default LegalNotice;
